<template>
  <div>
    <div class="bigBox">
      <div v-show="!this.knowedgeQeck" class="workcenter">
        <Card dis-hover class="sum-card-box2">
          <div class="center-01">
            <h3>我猜您想解决以下问题：</h3>
          </div>
          <div class="center-02">
            <div>
              <Input
                v-model="descr"
                placeholder="请输入关键词"
                clearable
                @on-change="Search1(descr)"
                icon="ios-search"
              />
            </div>
            <div class="center-03">
              <Table
                :columns="columns"
                :data="data"
                stripe
                highlight-row
                @on-row-click="rowClick"
              ></Table>
            </div>
          </div>
        </Card>
      </div>

      <div class="workleft">
        <Form
          ref="form"
          :model="forms"
          :label-width="150"
          :disabled="action == 'view' ? true : false"
        >
          <div v-show="!this.knowedgeQeck" class="first-line">
            <p
              style="
                color: #00050e;
                font-size: 0.875rem;
                padding-top: 5px;
                text-align: left;
                width: 8%;
                display: inline-block;
                margin-right: 5px;
              "
            >
              问题描述:
            </p>
            <div class="left-01">
              <Input
                v-model="getText"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 3 }"
                placeholder="请输入或点击左侧选择"
              ></Input>
            </div>
          </div>
          <div v-show="!this.knowedgeQeck" class="first-line">
            <div class="left-02" v-html="programme"></div>
          </div>

          <div class="first-line">
            <div>
              <p>设备信息:</p>
              <Select
                class="Select"
                v-model="EquipmentValue"
                filterable
                placeholder="请选择或搜索设备信息"
                clearable="true"
                @on-change="SelectEquipment(EquipmentValue)"
              >
                <Option v-for="item in EquipmentList" :value="item.Num" :key="item.Num"
                  >{{ item.value }}
                </Option>
              </Select>
            </div>
            <div>
              <p><span style="color: red">*</span>故障类型:</p>
              <Input
                class="Select"
                v-model="FaultTypeText"
                placeholder="请选择问题描述"
                disabled
              ></Input>
            </div>
            <!--            <div>-->
            <!--              <p><span style="color: red">*</span>故障类型:</p>-->
            <!--              <Select-->
            <!--                  class="Select"-->
            <!--                  v-model="typeId"-->
            <!--                  placeholder="请选择问题描述"-->
            <!--                  @on-change="changeTypeId(typeId)"-->
            <!--              >-->
            <!--                <Option-->
            <!--                    v-for="item in workList"-->
            <!--                    :value="item.typeId"-->
            <!--                    :key="item.typeId"-->
            <!--                >{{ item.name }}-->
            <!--                </Option>-->
            <!--              </Select>-->
            <!--            </div>-->
          </div>
          <div v-show="!this.knowedgeQeck" class="workleft-1">
            <div class="workleft-11">
              <p>派单类型:</p>
              <RadioGroup
                v-model="sendType"
                @on-change="changeOrderType(sendType)"
                class="RadioGroup"
              >
                <Radio :label="2">自动派单</Radio>
                <Radio :label="1">手动派单</Radio>
                <Radio :label="3">抢单派单</Radio>
              </RadioGroup>
              <Select
                class="left-12-Select"
                v-model="engineer1"
                placeholder="请选择维修员"
                clearable="true"
                @on-change="Selectengineer2(engineer1)"
                v-show="single == false ? true : false"
              >
                <Option
                  v-for="item in engineerList2"
                  :value="item.nickName"
                  :key="item.userId"
                  >{{ item.nickName }}
                </Option>
              </Select>
            </div>
          </div>
          <div v-show="!this.knowedgeQeck" class="workleft-2">
            <Button type="info" @click="handleSubmit" size="default" class="button2"
              >保 存
            </Button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      data: [],
      data2: [],
      descr: "",
      allData: [],
      typeId: "",
      FaultTypeText: "",
      descr2: "",
      allData2: [],
      DepartmentValue: "",
      EquipmentValue: "",
      sendType: 2, //派单类型
      single: true,
      getText: "",
      maintainerContent: "",
      programme: "",
      EquipmentList: {}, //设备列表
      workList: {},
      engineerList2: {},
      maintainerId: "",
      engineer1: "",
      repairPhone: "",
      repairBy: "",
      color2: false,
      mname: "work",
      RepairText: "",
      key: "id",
      columns: [
        {
          title: "问题描述",
          minWidth: 170,
          align: "left",
          key: "descr",
        },
      ],
      url: {},
    };
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  mounted() {},
  async created() {
    await this.loadUser();
    await this.loadfaultData();
    this.changeOrderType(2);
    this.loadCommonData();
  },
  methods: {
    async loadUser() {
      let res = await $utils.api.load(`/customer/getInfo`, {});
      try {
        if (res && res.user) {
          this.repairBy = res.user.nickName;
          this.repairPhone = res.user.phonenumber;
          this.DepartmentValue = res.user.deskId;
          if (this.DepartmentValue) {
            await this.OnDepartment(this.DepartmentValue);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    //选择维修员
    Selectengineer2(item) {
      if (this.engineerList2.length > 0) {
        for (let i = 0; i < this.engineerList2.length; i++) {
          let a = this.engineerList2[i];
          if (a.name == item) {
            this.maintainerId = a.id;
          }
        }
      }
    },

    //选择设备
    async SelectEquipment(item) {
      let list = this.EquipmentList;
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let a = list[i];
          if (!item) {
            await this.loadCommonData(null);
          }
          if (a.value == item) {
            this.facilityNo = a.Num;
            await this.loadfaultData(this.facilityNo);
          }
        }
      }
    },
    //选择设备
    async loadfaultData(facilityNo) {
      if (facilityNo) {
        let q = {};
        q.facilityNum = facilityNo;
        let res = await $utils.api.load(`/customer/customer/facility/workTypeHome`, q);
        console.log(4444, res);
        if (res) {
          let list = res.rows;
          if (!list || list.length === 0) {
            this.workList = {};
            this.typeId = "";
            this.getText = "";
          } else {
            await this.loadCommonData(list[0].id);
            this.typeId = list[0].id;
            this.FaultTypeText = list[0].name;
            await this.changeTypeId(this.typeId);
          }
        }
      }
    },
    //派单类型
    changeOrderType(item) {
      if (item == 1) {
        this.single = false;
      } else {
        this.single = true;
      }
    },
    Search1(descr) {
      let keyword = this.descr;
      let allData = this.allData;
      let newData = [];
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {};
        let descrOld = item.descr;
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item);
          this.data = newData;
        }
      }
    },
    async loadCommonData(id) {
      let q = {};
      q.workTypeId = id;
      q.workType = 1;
      let res = await $utils.api.load("/customer/customer/common/noPageCommonList", q);
      if (res) {
        if (res.code > 0) {
          let list = res.rows || [];
          this.allData = list;
          this.data = list;
        }
      }
    },
    async rowClick(row) {
      // 点击选择行

      let descr = row.descr;
      console.log(row.recommendation);
      this.getText = descr;
      await this.loadData(row.id);
      if (row.recommendation != "") {
        this.programme = row.recommendation;
      } else {
        this.programme = "暂无处理方案";
      }
    },
    async loadData(id) {
      let q = {};
      q.id = id;
      let res = await $utils.api.load("/customer/customer/common/pageList", q);
      if (res) {
        if (res.code > 0) {
          this.FaultTypeText = res.data.name;
          this.typeId = res.data.id;
          this.changeTypeId(this.typeId); //查询维修员
        }
      }
    },
    async OnDepartment(DepartmentValue) {
      if (this.DepartmentValue) {
        this.getText = "";
        this.programme = "";
        this.EquipmentList = [];
        this.EquipmentValue = "";
      }
      let q = {};
      q.state = 2;
      q.deskId = DepartmentValue;
      let res = await $utils.api.load("/customer/customer/facility/selectList", q, "get");
      let list = res.rows;
      let arr = [];
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          let obj = {};
          (obj.value = item.assetNum + "_" + item.facilityName + "_" + item.facilityType),
            (obj.Num = item.facilityNum),
            arr.push(obj);
        }
      } else {
        this.EquipmentValue = "";
      }
      this.EquipmentList = arr;
    },
    async changeTypeId(typeId) {
      if (typeId) {
        // this.loadChildData(typeParentId);
        // 通过pk查询字典数据
        let res = await $utils.api.load(`/customer/customer/workType/type/${typeId}`);
        if (res && res.rows) {
          this.engineerList2 = res.rows;
        }
      }
    },

    handleSubmit() {
      if (!this.getText) {
        $utils.toast.error("请填写问题描述");
        return;
      }
      if (!this.typeId) {
        $utils.toast.error("请选择故障类型");
        return;
      }
      if (this.sendType == 1) {
        if (!this.engineer1) {
          $utils.toast.error("请选择维修员");
          return;
        }
      }
      let q = {
        repairBy: this.repairBy,
        repairPhone: this.repairPhone,
        descr: this.getText,
        deskId: this.DepartmentValue,
        facilityNo: this.EquipmentValue,
        typeId: this.typeId,
        sendType: this.sendType,
        maintainerId: this.engineer1,
        isKnow: 0,
        maintainType: 2,
        repairSource: 5,
      };
      if (this.EquipmentValue) {
        q.isFastOrder = 0;
      } else {
        q.isFastOrder = 1;
      }
      q.state = 1;
      this.sloading = true;
      $utils.api
        .load(`/customer/customer/workOrder`, q, "POST")
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success("保存成功");
          }
          setTimeout(() => {
            this.rest();
            window.location.reload();
          }, 1000);
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    rest() {
      this.descr = "";
      this.deskId = "";
      this.facilityNo = "";
      this.typeId = "";
      this.sendType = "";
      this.maintainerId = "";
      this.isKnow = "";
      this.maintainType = "";
    },
  },
};
</script>

<style lang="less" scoped>
.bigBox {
  height: calc(90%);
  display: flex;
  justify-content: space-between;

  .workleft {
    width: 100%;
    margin-left: 1%;

    .radio-work {
      margin-left: 100px;
    }

    h3 {
      margin-bottom: 10px;
    }

    .first-line {
      margin-top: calc(20px);
      width: calc(100%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .SelectT {
          width: 100%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        .Select {
          width: 85%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 16.5%;
          display: inline-block;
          margin-right: 5px;
        }
      }

      .left-01 {
        display: inline-block;
        width: 90.5%;

        vertical-align: top;

        /deep/ .ivu-input {
          display: inline-block;
          width: 100%;
          height: calc(25%);
          line-height: 1.5;
          padding: 4px 7px;
          font-size: 14px;
          border: 1px solid #dcdee2;
          border-radius: 4px;
          color: #3871f1;
          background-color: #fff;
          background-image: none;
          position: relative;
          cursor: text;
          transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
            box-shadow 0.2s ease-in-out;
        }
      }

      .left-02 {
        width: 90.5%;
        border-radius: 5px;
        background-color: #f3f3f3;
        border: 1px rgb(220, 222, 226) solid;
        overflow: auto;
        height: 100px;
        color: #ee0000;
        margin-left: 8.4%;
      }
    }
    .compare-line {
      margin-top: calc(10px);
      width: calc(87%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .Select {
          width: 43%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 8.5%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
    .service-line {
      margin-top: calc(200px);
      width: calc(87%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .Select {
          width: 43%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 8.5%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .workleft-1 {
      height: 33px;
      margin-top: 310px;
      width: 100%;

      .workleft-11 {
        font-size: 12px;
        display: flex;

        .RadioGroup {
          color: #00050e;
          margin-top: 4px;
          width: 30%;
        }

        .left-12-Select {
          width: 30%;
          display: inline-block;
        }

        p {
          color: #00050e;
          width: 8%;
          margin-right: calc(20px);
          padding-top: 5px;
          font-size: 14px;
        }
      }
    }

    .workleft-2 {
      position: absolute;
      width: 73.8%;
      bottom: 15px;
      .button2 {
        width: 100%;
      }
    }
    .workleft-3 {
      position: absolute;
      width: 33%;
      bottom: 15px;
      .button2 {
        width: 100%;
      }
    }
    .workleft-4 {
      position: absolute;
      margin-left: 33.6%;
      width: 33%;
      bottom: 15px;
      .button2 {
        width: 100%;
      }
    }

    .workleftCompare {
      margin-top: calc(10px);

      .knowledge {
        margin: 10px 5px 5px 120px;
        width: 125px;
        height: 32px;
        background-color: #1890ff;
        color: #f6f8f7;
        border: none;
        border-radius: 5px;
      }

      .submit {
        margin: 10px 5px 5px 5px;
        width: 80px;
        height: 32px;
        background-color: #1890ff;
        color: #f6f8f7;
        border: none;
        border-radius: 5px;
      }
    }
  }

  .workcenter {
    width: 30%;
    height: 100%;

    i {
      cursor: pointer;
    }

    .center-01 {
      color: #00050e;
      width: 100%;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }

    .center-02 {
      height: 580px;

      .center-03 {
        height: 90%;
        overflow: auto;

        /deep/ .ivu-table {
          width: inherit;
          height: 100%;
          max-width: 100%;
          overflow: hidden;
          color: #3871f1;
          font-size: 14px;
          background-color: #fff;
          box-sizing: border-box;
        }
      }
    }
  }
}

.sum-card-box2 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;
}
</style>
